import { useCreate, useDelete, useDetail, useList, useUpdate, usePartialUpdate, useAction, fetchApi } from "@inmagik/react-crud"
import type { Story } from "../types"
import { API_URL } from "../constants"
import { useAuth } from "../auth"
import { useCallback } from "react"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"

export function useStoriesList(params: Record<string, string> = {}) {
  return useList<Story>(`${API_URL}/admin/stories`, {
    query: params,
  })
}

export function useStory(id: number | undefined) {
  return useDetail<Story>(`${API_URL}/admin/stories`, id?.toString())
}

export function useCreateStory() {
  return useCreate<Story>(`${API_URL}/admin/stories`, {
    encode: "formdata",
  })
}

export function useUpdateStory() {
  return useUpdate<Story>(`${API_URL}/admin/stories`, {
    encode: "formdata",
  })
}

export function useDeleteStory() {
  return useDelete(`${API_URL}/admin/stories`)
}

export function usePartialUpdateStory() {
  return usePartialUpdate<Story>(`${API_URL}/admin/stories`)
}

export function usePartialUpdateStoryFormData() {
  return usePartialUpdate<Story>(`${API_URL}/admin/stories`, {
    encode: "formdata",
  })
}

export function useDeleteMultiStory() {
  return useAction(`${API_URL}/admin/stories/delete_multi/`, {
    method: "POST",
    responseType: "text",
  })
}

export function useStoryLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/stories/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<Story>
  }, [])
}

export function useStoriesLazy() {
  const auth = useAuth()
  return useCallback((params: Record<string, string | number | Array<number>>) => {
    const qs = normalizeParams(params).toString()
    return fetchApi(`${API_URL}/admin/stories?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: Story[] }>
  }, [])
}
